<template>
  <div class="div-detail">
    <div class="detail-header">
      <div class="title">{{ companyName }}</div>
      <div v-if="returnName">
        <span class="btn-return" @click="returnZfCompany()">返回</span>
      </div>
    </div>
    <div class="detail-content">
      <el-tabs v-model="activeName" v-if="manageType === '产废单位'">
        <el-tab-pane :lazy="true" label="基本信息" name="first">
          <div class="tabs-content">
            <basic></basic>
          </div>
        </el-tab-pane>
        <el-tab-pane :lazy="true" label="年度危废产生情况" name="second">
          <year-danger-waster-data></year-danger-waster-data>
        </el-tab-pane>
        <el-tab-pane :lazy="true" label="合同管理" name="third">
          <div class="tabs-content">
            <year-danger-waster></year-danger-waster>
          </div>
        </el-tab-pane>
        <el-tab-pane :lazy="true" label="预警/警报" name="fourth">
          <warning></warning>
        </el-tab-pane>
      </el-tabs>
      <el-tabs v-model="activeName" v-else>
        <el-tab-pane :lazy="true" label="基本信息" name="first">
          <cz-basic></cz-basic>
        </el-tab-pane>
        <el-tab-pane :lazy="true" label="其他信息" name="second">
          <cz-other></cz-other>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import basic from '@/views/qyCompany/basic.vue';
import czOther from "@/views/qyCompany/czOther.vue";
import yearDangerWasterData from './components/yearDangerWasterData.vue';
import warning from './components/warning.vue';
import yearDangerWaster from '@/views/qyCompany/yearDangerWaster.vue';
import czBasic from "@/views/qyCompany/czBasic.vue";
export default {
  props: {

  },
  components: { basic, yearDangerWasterData, yearDangerWaster, warning, czBasic, czOther },
  data() {
    return {
      loading: false,
      visible: false,
      activeName: 'first',
      companyId: 0,
      companyName: "",
      manageType: "",
      returnName: "",
    }
  },
  methods: {
    // returnZfCompany() {
    //   if (this.returnName) {
    //     this.$router.push({ name: this.returnName })
    //   } else {
    //     this.$router.back()
    //   } 
    // },
    getCompanyInfo(company) {
      this.company = company;
      this.visible = true;
    },
    open() {
    },
  },
  mounted() {
  },
  created() {
    this.companyId = this.$route.params.companyId
    this.companyName = this.$route.params.companyName
    this.manageType = this.$route.params.manageType
    this.returnName = this.$route.params.returnName
  }
}
</script>

<style lang="scss" scoped>
.div-detail {
  height: 100%;

  .detail-header {
    display: flex;
    justify-content: space-between;
    padding: 5px 5px 0px 5px;
    height: 30px;
    line-height: 30px;

    .title {
      font-size: 18px;
      font-weight: bold;
      border-left: 8px solid #1890ff;
      padding-left: 12px;
    }

    .btn-return {
      color: #1890ff;
      cursor: pointer;
    }
  }

  .detail-content {
    height: calc(100% - 30px);
    padding: 10px;

    .el-tabs {
      width: 100%;
      height: 100%;

      /deep/.el-tabs__content {
        height: calc(100% - 55px);

        .el-tab-pane {
          height: 100%;
        }
      }
    }
  }

  .tabs-content {
    height: 100%;


  }
}
</style>